export default __webpack_public_path__ + "static/media/img-0711-belgium-half-face.2180e21a.png";